import { Link, useSearchParams } from 'react-router-dom';
import { ArrowRight, FileText, Stethoscope, Brain, Calendar, Shield, Sparkles, BarChart, Map, Heart } from '../components/Icons.jsx';
import SubNav from '../components/SubNav.jsx';

const sections = {
  all: { label: 'All', items: [] },
  application: {
    label: 'Application',
    items: [
      { to: '/timeline', icon: Calendar, title: 'Application timeline', body: 'GCSEs to results day. 15 Oct UCAS deadline is the one to watch.' },
      { to: '/calendar', icon: Calendar, title: 'Your calendar', body: 'Plan your own diary. Imports UCAT prep blocks and key dates.' },
      { to: '/ps-analyser', icon: FileText, title: 'PS analyser', body: 'Paste your draft, get a structured score on reflection, evidence and GMC alignment.' },
      { to: '/strategy-audit', icon: Sparkles, title: 'Strategy audit', body: '30-min audit pinpointing the single biggest gap in your application.' }
    ]
  },
  we: {
    label: 'Work experience',
    items: [
      { to: '/career-camp', icon: Stethoscope, title: 'Career Camp', body: 'Five days inside a working NHS hospital + hospice. Bursaries up to 100%.' },
      { to: '/we-map', icon: Map, title: 'Work experience near you', body: 'Map of hospitals, hospices and GP surgeries near your postcode.' },
      { to: '/we-quiz', icon: BarChart, title: 'Work experience strength quiz', body: 'Score your work experience on four axes. Find the gap.' },
      { to: '/we-finder', icon: Stethoscope, title: 'Work experience finder & log', body: 'Filter placements + log hours in a browser-local diary.' },
      { to: '/we-reflection', icon: FileText, title: 'Reflection generator', body: 'Turn one memory into a PS-ready paragraph mapped to a GMC outcome.' }
    ]
  },
  interview: {
    label: 'Interview prep',
    items: [
      { to: '/hot-topics', icon: Brain, title: 'NHS hot topics', body: 'Current ethics and policy debates. Interview-ready.' },
      { to: '/tutor-match', icon: Shield, title: 'Find your tutor', body: 'Three-question match for the right Medic Mind tutor. MMI prep.' }
    ]
  },
  decide: {
    label: 'Deciding on medicine',
    items: [
      { to: '/doctor-salaries', icon: Heart, title: 'Doctor salaries', body: 'NHS pay across specialties — from FY1 to consultant. Compare interactively.' }
    ]
  }
};

export default function Apply() {
  const [params] = useSearchParams();
  const tab = params.get('tab') || 'all';
  const subNav = [
    { to: '/apply', label: 'All', end: true },
    ...Object.keys(sections).filter((k) => k !== 'all').map((k) => ({ to: `/apply?tab=${k}`, label: sections[k].label }))
  ];
  const visible = tab === 'all' ? Object.entries(sections).filter(([k]) => k !== 'all') : [[tab, sections[tab]]];

  return (
    <>
      <div className="page-head">
        <h1>Apply</h1>
        <p className="subtitle">Personal statement, work experience, interviews, and deciding the path.</p>
      </div>

      <SubNav items={subNav} />

      {visible.map(([key, s]) => (
        s && s.items.length > 0 && (
          <div key={key} style={{ marginBottom: 26 }}>
            {tab === 'all' && <h2 style={{ margin: '0 0 12px', fontSize: 17 }}>{s.label}</h2>}
            <div className="r-grid-2">
              {s.items.map((it) => (
                <Link key={it.to} to={it.to} className="parents-card" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
                  <div className="icon-wrap"><it.icon /></div>
                  <h3 style={{ margin: '8px 0 6px', fontSize: 16 }}>{it.title}</h3>
                  <p style={{ color: 'var(--text-2)', fontSize: 13.5, margin: 0, lineHeight: 1.5 }}>{it.body}</p>
                  <span style={{ marginTop: 10, color: 'var(--accent)', fontSize: 13, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 }}>Open <ArrowRight width="14" height="14" /></span>
                </Link>
              ))}
            </div>
          </div>
        )
      ))}
    </>
  );
}
